import serv1 from "../../assets/serv1.svg"
import serv2 from "../../assets/serv2.svg"
import serv3 from "../../assets/serv3.svg"
import serv4 from "../../assets/serv4.svg"
import serv5 from "../../assets/serv5.svg"
import serv6 from "../../assets/serv6.svg"

export const dataService = [
    { name: 'Plumbing', img: serv1 },
    { name: 'Repairs', img: serv4 }, { name: 'Gardening', img: serv3 }, { name: 'Gardening', img: serv3 }, { name: 'Gardening', img: serv3 }, { name: 'Gardening', img: serv3 }, { name: 'Gardening', img: serv3 },
    { name: 'Repairs', img: serv4 }, { name: 'Gardening', img: serv3 }, { name: 'Wood Work', img: serv4 }, { name: 'Cleaning', img: serv5 }, { name: 'Deliveries', img: serv6 }
]